import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShareWebOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M20 15V17.3101C20 18.6401 19.6269 20 16.8613 20H6.40039C4.58301 20 4 19.2183 4 16.7827V15H2V16.7827C2 18.0732 2 22 6.40039 22H16.8613C20.1269 22 22 20.2905 22 17.3101V15H20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M11 6.13586V15H13V6.13586L16.9316 10.0679L18.3457 8.65381L12 2.30762L5.6543 8.65381L7.06836 10.0679L11 6.13586Z",
    fill: "currentColor"
  }));
}